import {
    AnyAction,
    createSlice,
    PayloadAction,
    Reducer,
} from '@reduxjs/toolkit';

import { ApiStatus } from '../../types';

import { initialStateRepayment as initialState } from './repaymentDefaultValue';
import {
    RepaymentAccount,
    RepaymentApiData,
    RepaymentEndpoints,
    RepaymentState,
} from './repaymentTypes';

const repaymentSlice = createSlice({
    name: 'repayment',
    initialState,
    reducers: {
        getRepayment(state) {
            state.getRepaymentApiStatus = ApiStatus.Pending;
        },
        getRepaymentFulfilled(state, action: PayloadAction<RepaymentApiData>) {
            const { content, selectedRepaymentAccount, availableRepaymentAccount } = action.payload;

            if (content) {
                try {
                    state.content = JSON.parse(content);
                } catch {
                    console.log('Invalid JSON - Repayment Content');
                }
            }
            state.repaymentAccounts = availableRepaymentAccount;
            state.selectedAccount = selectedRepaymentAccount;
            state.getRepaymentApiStatus = ApiStatus.Fulfilled;
        },
        getRepaymentRejected(state) {
            state.getRepaymentApiStatus = ApiStatus.Rejected;
        },
        submitRepayment(state, action: PayloadAction<RepaymentAccount>) {
            state.submitRepaymentApiStatus = ApiStatus.Pending;
        },
        submitRepaymentFulfilled(
            state,
            action: PayloadAction<RepaymentAccount>,
        ) {
            state.selectedAccount = action.payload;
            state.submitRepaymentApiStatus = ApiStatus.Fulfilled;
        },
        submitRepaymentRejected(state) {
            state.submitRepaymentApiStatus = ApiStatus.Rejected;
        },
        updateRepaymentEndPoints: (state, action: PayloadAction<RepaymentEndpoints>) => {
            state.apiEndpoints = action.payload;
        },
        resetRepaymentStatus(state) {
            state.getRepaymentApiStatus = ApiStatus.Idle;
            state.submitRepaymentApiStatus = ApiStatus.Idle;
        },
    },
});

export const {
    getRepaymentFulfilled,
    getRepaymentRejected,
    getRepayment,
    submitRepayment,
    submitRepaymentFulfilled,
    submitRepaymentRejected,
    updateRepaymentEndPoints,
    resetRepaymentStatus,
} = repaymentSlice.actions;

export const repaymentReducer: Reducer<RepaymentState, AnyAction> = repaymentSlice.reducer;
